'use strict';

const $ = require('jquery');

let buttons = {
  svgSprite: function(key){
    let retVal = '',
      id = '';

    if( typeof key === 'undefined' || !key ) return retVal;

    // check that svg-icon with key as ID exists
    if( key.indexOf('#') === -1 ) id = '#'+key;
    else {
      id = key;
      key = key.split('#')[1];
    }

    if( !$(id).length ) return retVal;

    retVal =
     `<svg class="icon-svg ${key}">
        <use xlink:href="${id}"></use>
      </svg>`;
    return retVal;
  },
  addHeroScrollButtons: function(){
    // this functions adds an arrow link to the bottom of home and tyres page heros
    // those heros fill screen's vertical height
    // NHT has link to sizes-element with it's text (technical specifications), if found on the pafe
    const isHeavy = document.querySelector('body').classList.contains('nht');
    const sizes = isHeavy ? document.getElementById('sizes') : null;
    const sizesText = sizes?.querySelector('h2')?.textContent || null;

    $('.home #hero, .tyres #hero, .hero-2018.season-depending, .section-product-hero').each(function( i ){
      let title = typeof window.loc !== 'undefined' && window.loc.title ? 'title="'+window.loc.title+'"' : '';
      let scroll_down_btn = `
        <div class="hero-scroll-button js-added" aria-hidden="true">
          <a rel="noindex nofollow" href="#${sizesText ? 'sizes' : `scroll-down-${i}`}" ${title}>
          ${sizesText ? `<span class="hero-sizes-link">${sizesText}</span>` : ''}

            <svg class="icon-svg icon-scroll-down">
              <use xlink:href="#icon-scroll-down"></use>
            </svg>
          </a>
        </div>`,
        scroll_target = `
          <span id="scroll-down-${i}"></span>
        `;

      $(this)
        .append(scroll_down_btn)
        .after(scroll_target);

      scroll_down_btn = $('.hero-scroll-button');
      scroll_down_btn.on('click', function(e){
        e.preventDefault();
        let anchor = $(this).find('a').attr('href');
        $('html,body').animate({scrollTop: $(anchor).offset().top});
      });
    });
  },
  init: function(){
    this.addHeroScrollButtons();
  }
}; // buttons

export default buttons;
